export default __webpack_public_path__ + "static/media/photo 12.3c90fc1f.jpg";